(function () {
  var DESKTOP_QUERY = '(min-width: 1200px)';
  var selector = '.header-v1-h1 .navbar-nav > li.es-has-dropdown';
  var items = [];

  function closeAll(except) {
    items.forEach(function (item) {
      if (item !== except) {
        clearTimeout(item._esEnterTimer);
        clearTimeout(item._esLeaveTimer);
        item.classList.remove('es-dropdown-open');
      }
    });
  }

  function bindDesktopBehavior() {
    items = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!items.length) return;

    items.forEach(function (item) {
      if (item._esDropdownBound) return;
      item._esDropdownBound = true;

      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia(DESKTOP_QUERY).matches) return;
        clearTimeout(item._esLeaveTimer);
        item._esEnterTimer = setTimeout(function () {
          closeAll(item);
          item.classList.add('es-dropdown-open');
        }, 90);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(item._esEnterTimer);
        item._esLeaveTimer = setTimeout(function () {
          item.classList.remove('es-dropdown-open');
        }, 150);
      });

      item.addEventListener('focusin', function () {
        if (!window.matchMedia(DESKTOP_QUERY).matches) return;
        clearTimeout(item._esLeaveTimer);
        closeAll(item);
        item.classList.add('es-dropdown-open');
      });

      item.addEventListener('focusout', function (event) {
        if (!window.matchMedia(DESKTOP_QUERY).matches) return;
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        item._esLeaveTimer = setTimeout(function () {
          item.classList.remove('es-dropdown-open');
        }, 120);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
      }
    });
  }

  function handleBreakpointChange() {
    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      document.querySelectorAll(selector + '.es-dropdown-open').forEach(function (item) {
        item.classList.remove('es-dropdown-open');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindDesktopBehavior();
      handleBreakpointChange();
      window.addEventListener('resize', handleBreakpointChange, { passive: true });
    });
  } else {
    bindDesktopBehavior();
    handleBreakpointChange();
    window.addEventListener('resize', handleBreakpointChange, { passive: true });
  }
})();
